/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import $ from 'jquery';
import Vue from 'vue';
import 'bootstrap';
import 'select2';
import {mapKeys, camelCase} from 'lodash';

import initConfirmation from 'legacy/_general/confirmation_window/confirmation_window';
import initializeDatepicker from 'legacy/_general/elements/datepicker/datepicker';
import initSelect2 from 'legacy/_general/init_select2';
import CommentsBlock from '@/pages/sor/info/pages/components/comments/Comments.vue';
import RichText from '@/components/rich_text/RichText.vue';
import initEllipsis from 'legacy/_general/elements/ellipsis/ellipsis';
import CaDetails from '@/pages/settings/custom_attributes/CaDetails.vue';

import Schedule from '@/components/recurrence/Schedule.vue';
import RecurrenceWrapper from '@/components/cards/recurrence/RecurrenceWrapper.vue';
import FetchersTab from '@/components/fetchers/FetchersTab.vue';
import Attachments from '@/components/documents/Attachments.vue';
import ExternalAttachments from '@/components/documents/ExternalAttachments.vue';
import ObjectStatusTransition from '@/components/object_actions/ObjectStatusTransition.vue';
import ObjectReview from '@/components/object_actions/ObjectReview.vue';
import ObjectConclusion from '@/components/object_actions/ObjectConclusion.vue';
import ObjectStatusDropdown from '@/components/object_actions/ObjectStatusDropdown.vue';
import BookmarkLink from '@/components/bookmark_link/BookmarkLink.vue';
import initDropdownPresenters from 'legacy/sor/presenters/init_dropdown_presenter';
import SurveyAnswerMappingItems from '@/pages/survey/components/survey_answer/SurveyAnswerMappingItems';

import RiskScoringTab from '@/components/risk_scoring_tab/RiskScoringTab.vue';

import {ProfileIcon} from 'zenComponents';

import 'url-search-params-polyfill';

export default function () {
  initConfirmation();
  initializeDatepicker();
  initEllipsis();
  initDropdownPresenters();

  // Initialize Bootstrap tooltips
  const tooltipTargets = $('.js-init-tooltip');
  if (tooltipTargets.length) {
    tooltipTargets.tooltip().removeClass('js-init-tooltip');
  }

  $('body').tooltip({
    selector: '.js-person-extra-info-tooltip',
    html: true,
    template: `<div class="info-tooltip" role="tooltip">
      <div class="tooltip-inner"></div>
    </div>`,
    offset: '0, 5',
  });

  // Select 2
  const select2Config = {
    width: '100%',
    minimumResultsForSearch: 6,
  };
  // this cannot be arrow function because jquery uses `this` for element
  $('.js-init-select2:not(.select2-hidden-accessible)').each(function () {
    initSelect2(this, select2Config);
  });
  $('.js-init-select2-tags:not(.select2-hidden-accessible)').select2({
    ...select2Config,
    tags: true,
  });

  // Rich text editor
  $('rich-text').each(function () {
    new Vue({
      el: this,
      components: {RichText},
    });
  });

  // Comments component
  $('comments-block').each(function () {
    new Vue({
      el: this,
      render: html => html(CommentsBlock, {
        props: {
          commentList: JSON.parse(this.dataset.commentList),
          canComment: this.dataset.canComment === 'True',
          csrf: this.dataset.csrf,
          objectType: this.dataset.objectType,
          objectId: parseInt(this.dataset.objectId),
          apiUrl: this.dataset.apiUrl,
        },
      }),
    });
  });

  //  Profile Icon Block
  $('profile-icon-block').each(function () {
    new Vue({
      el: this,
      render: html => html(ProfileIcon, {
        props: {
          model: {
            ...(this.dataset || {}),
          },
        },
      }),
    });
  });

  // Risk scoring component
  $('risk-scoring-tab').each(function () {
    new Vue({
      el: this,
      render: html => html(RiskScoringTab, {
        props: {
          endpoints: JSON.parse(this.dataset.endpoints),
          id: parseInt(this.dataset.id, 10),
          csrf: this.dataset.csrf,
        },
      }),
    });
  });

  // Fetchers tab component
  $('fetchers-tab').each(function () {
    new Vue({
      el: this,
      render: html => html(FetchersTab, {
        props: {...this.dataset},
      }),
    });
  });

  // Documents modal
  const documentsEditModalEl = document.querySelector(
    '#documents-edit-modal-container');

  if (documentsEditModalEl) {
    GGRC.zenModal.show({
      type: 'DocumentsEditModal',
      data: documentsEditModalEl.dataset,
      config: {ignoreUrl: true},
    });
  }

  // Attachments
  $('attachments').each(function () {
    new Vue({
      el: this,
      render: html => html(Attachments, {
        props: {...this.dataset},
      }),
    });
  });

  // External Attachments component
  $('external-attachments').each(function () {
    new Vue({
      el: this,
      render: html => html(ExternalAttachments, {
        props: {
          externalAttachmentList: JSON.parse(
            this.dataset.externalAttachmentList
          ),
        },
      }),
    });
  });

  // Custom attributes details block
  $('ca-details-block').each(function () {
    new Vue({
      el: this,
      render: html => html(CaDetails, {
        props: {
          customAttributes: JSON.parse(this.dataset.customAttributes),
          csrf: this.dataset.csrf,
          objectType: this.dataset.objectType,
          objectId: parseInt(this.dataset.objectId),
          layout: JSON.parse(this.dataset.layout),
        },
      }),
    });
  });

  // Recurrence modal
  const recWrapper = document.getElementById('recurrence-wrapper');

  if (recWrapper) {
    const recDataset = recWrapper.dataset;
    const recFlag = recDataset.updatedRecurrenceFlag.toLowerCase();
    let schedule = JSON.parse(recDataset.schedule) || {};
    schedule = mapKeys(schedule, (v, k) => camelCase(k));
    new Vue({
      el: recWrapper,
      render: html => html(RecurrenceWrapper, {
        props: {
          ...recDataset,
          initialConfig: {...schedule},
          scheduleData: JSON.parse(recDataset.scheduleData),
          updatedRecurrenceFlag: JSON.parse(recFlag),
        },
      }),
    });
  }

  // Schedule block
  $('schedule-presenter').each(function () {
    const props = {...this.dataset};
    new Vue({
      el: this,
      render: html => html(Schedule, {
        props,
      }),
    });
  });

  // Object status transition
  $('object-status-transition').each(function () {
    new Vue({
      el: this,
      render: html => html(ObjectStatusTransition, {
        props: {
          ...this.dataset,
          prevBtn: JSON.parse(this.dataset.prevBtn),
          nextBtn: JSON.parse(this.dataset.nextBtn),
          inDropdown: this.dataset.inDropdown === 'True',
        },
      }),
    });
  });

  // Object review
  $('object-review').each(function () {
    new Vue({
      el: this,
      render: html => html(ObjectReview, {
        props: {...this.dataset},
      }),
    });
  });

  // Object conclusion
  $('object-conclusion').each(function () {
    new Vue({
      el: this,
      render: html => html(ObjectConclusion, {
        props: {
          ...this.dataset,
          presenterConfig: JSON.parse(this.dataset.presenterConfig),
        },
      }),
    });
  });

  // Object status dropdown
  $('object-status-dropdown').each(function () {
    new Vue({
      el: this,
      render: html => html(ObjectStatusDropdown, {
        props: {
          ...this.dataset,
          options: JSON.parse(this.dataset.options),
          readonly: JSON.parse(this.dataset.readonly),
        },
      }),
    });
  });

  // Bookmark link (star icon top right on listings)
  $('bookmark-link').each(function () {
    const params = new URLSearchParams(window.location.href);
    let bookmark;
    if (params.has('bookmark')) {
      bookmark = JSON.parse(decodeURIComponent(params.get('bookmark')));
    };

    new Vue({
      el: this,
      render: html => html(
        BookmarkLink, {props: {...this.dataset, ...bookmark}}
      ),
    });
  });

  // Answer mapping (Responses tab in SurveyResponse object info)
  $('survey-answer-mapping-items').each(function () {
    new Vue({
      el: this,
      render: html => html(SurveyAnswerMappingItems, {
        props: {
          mappings: JSON.parse(this.dataset.mappings),
          surveyResponseId: this.dataset.surveyResponseId,
          surveyAnswerId: parseInt(this.dataset.surveyAnswerId, 10),
          csrf: this.dataset.csrf,
        },
      }),
    });
  });
};
